"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepBar = exports.createStepText = exports.createCircle = exports.createLines = exports.reMappedProps = void 0;
var React = require("react");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var reMappedProps = function (props) {
    // Calculate all points
    var totalSteps = props.steps.length;
    var offset = (100 - (totalSteps - 1) / totalSteps * 100) / 2;
    var points = props.steps.map(function (text, key) { return ({
        key: key,
        text: text,
        active: key <= props.currentStep,
        x: offset + key / totalSteps * 100,
        xP: offset + (key - 1) / totalSteps * 100
    }); });
    return __assign(__assign({}, props), { points: points });
};
exports.reMappedProps = reMappedProps;
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('StepBar'), (0, recompose_1.mapProps)(exports.reMappedProps), (0, recompose_1.defaultProps)({
    showStepText: true
}), recompose_1.pure);
var createLines = function (node) { return (React.createElement("line", { key: 'line-' + node.key, className: classNames('sok-stepbar-step-line', node.active && 'active'), x1: node.x + '%', x2: node.xP + '%', y1: '30', y2: '30' })); };
exports.createLines = createLines;
var createCircle = function (getNode, className) { return function (node) { return [
    React.createElement("circle", { key: 'circle-' + node.key, className: classNames('sok-stepbar-step-circle', node.active && 'active', className), cx: node.x + '%', cy: '30', r: '25', onClick: function () { return getNode && getNode(node.key); } }),
    React.createElement("text", { key: 'number-' + node.key, x: node.x + '%', y: '38', className: classNames('sok-stepbar-step-number', node.active && 'active', className), onClick: function () { return getNode && getNode(node.key); } }, node.key + 1)
]; }; };
exports.createCircle = createCircle;
var createStepText = function (node) { return (React.createElement("text", { key: 'text-' + node.key, x: node.x + '%', y: '72.5', className: 'sok-stepbar-step-text', textAnchor: 'middle' }, node.text)); };
exports.createStepText = createStepText;
exports.StepBar = enhance(function (props) { return (React.createElement("div", { className: classNames('sok-stepbar', props.className, props.onChange ? 'clickable' : '') },
    React.createElement("svg", null,
        React.createElement("g", { className: 'sok-stepbar-lines' }, props.points.slice(1, Infinity).map(exports.createLines)),
        React.createElement("g", { className: 'sok-stepbar-circles' }, props.points.map((0, exports.createCircle)(props.onChange, props.className))),
        React.createElement("g", { className: 'sok-stepbar-step-texts' }, props.showStepText && props.points.map(exports.createStepText))))); });
//# sourceMappingURL=index.js.map